export const getCurrentUrl = () => {
  return window.location.href.replace(window.location.origin, "");
};

export const getPreviousUrl = () => {
  return (window.history.state?.usr?.previous as string) || undefined;
};
